
export default {
  name: 'billing',
  label: 'Billing',
  link: 'billing',
  path: 'billing',
  props: true,
  icon: 'credit-card',
  description: 'Manage subscription health, billing access, and account charges.',
  component: () => import('@/components/TabPanel.vue'),
  requirePerm: 'manage_subscription',
  requireActive: false,
  requireGetter: 'notInApp',
  require: (state, getters) => !getters['userProfile/isWhiteLabel'],
  breadcrumbLeaf: true,
  children: [
    {
      name: 'billing-subscription',
      navIcon: 'CreditCard',
      label: 'Subscription',
      title: 'Billing Subscription',
      path: 'subscription/:view?',
      requireActive: false,
      component: () => import('./Subscription.vue')
        .catch(error => {
          console.error('Failed to route to Subscription', error)
          throw error
        })
    },
    {
      name: 'billing-invoices',
      navIcon: 'Receipt',
      label: 'Invoices',
      title: 'Billing Invoices',
      path: 'invoices',
      requireActive: false,
      component: () => import('./Invoices.vue'),
      require: (state, getters) => !!state.billingCustomerId && !getters.isFreeTrial
    },
    {
      name: 'billing-index',
      path: '',
      redirect: { name: 'billing-subscription' }
    }
  ]
}
